// extracted by mini-css-extract-plugin
export var section = "gallery-section-module--section--ph4Dv";
export var figure = "gallery-section-module--figure--0GzvH";